var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_1672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8544 5.40763C30.0165 8.9624 27.8205 12.8694 27.8205 12.8694C27.8205 12.8694 23.7396 11.0166 22.573 7.4618C21.4109 3.90704 23.6069 0 23.6069 0C23.6069 0 27.6878 1.85287 28.8544 5.40763Z",
    fill: "#5BC949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0641 7.04544C27.5094 8.20748 25.6565 12.2929 25.6565 12.2929C25.6565 12.2929 29.5635 14.4889 33.1183 13.3269C36.6731 12.1648 38.5259 8.07938 38.5259 8.07938C38.5259 8.07938 34.6189 5.88339 31.0641 7.04544Z",
    fill: "#5BC949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6603 11.6479C27.6603 11.6479 30.7439 9.6258 33.8503 9.3147",
    stroke: "#16AD00",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.945 42.5473C29.4081 42.5473 37.89 35.1776 37.89 26.0865C37.89 16.9955 29.4081 9.62573 18.945 9.62573C8.48197 9.62573 0 16.9955 0 26.0865C0 35.1776 8.48197 42.5473 18.945 42.5473Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6375 8.69702H9.93689V13.0433H27.6375V8.69702Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5988 11.1813C17.171 11.1813 19.2561 9.9994 19.2561 8.5415C19.2561 7.0836 17.171 5.90173 14.5988 5.90173C12.0266 5.90173 9.94147 7.0836 9.94147 8.5415C9.94147 9.9994 12.0266 11.1813 14.5988 11.1813Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9802 11.1813C25.5523 11.1813 27.6375 9.9994 27.6375 8.5415C27.6375 7.0836 25.5523 5.90173 22.9802 5.90173C20.408 5.90173 18.3228 7.0836 18.3228 8.5415C18.3228 9.9994 20.408 11.1813 22.9802 11.1813Z",
    fill: "#FFC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7921 14.1733C13.1211 14.1733 10.7512 12.8923 10.646 12.8328L11.0989 12.0184C11.1264 12.0322 13.8714 13.5007 19.2332 13.2034L19.2836 14.1321C18.762 14.1595 18.2679 14.1733 17.7921 14.1733Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5287 11.076C17.8242 9.66237 18.483 7.96963 18.515 7.901L19.3796 8.2487C19.3796 8.2487 18.8444 9.63035 19.3613 10.6643L18.5287 11.0806V11.076Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6831 23.6023C16.1985 23.6023 16.6163 23.1845 16.6163 22.669C16.6163 22.1536 16.1985 21.7357 15.6831 21.7357C15.1676 21.7357 14.7498 22.1536 14.7498 22.669C14.7498 23.1845 15.1676 23.6023 15.6831 23.6023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.207 23.6023C22.7224 23.6023 23.1403 23.1845 23.1403 22.669C23.1403 22.1536 22.7224 21.7357 22.207 21.7357C21.6915 21.7357 21.2737 22.1536 21.2737 22.669C21.2737 23.1845 21.6915 23.6023 22.207 23.6023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 26.2604C17.9202 26.2604 17.1562 25.0617 17.1241 25.0114L17.6503 24.682C17.8195 24.9474 18.3868 25.6428 18.9999 25.6428C19.4208 25.6428 19.8325 25.3179 20.2306 24.6866L20.7567 25.016C20.2397 25.8441 19.645 26.265 18.9999 26.265V26.2604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4153 25.1579C28.673 25.1579 28.8819 24.949 28.8819 24.6913C28.8819 24.4335 28.673 24.2246 28.4153 24.2246C28.1575 24.2246 27.9486 24.4335 27.9486 24.6913C27.9486 24.949 28.1575 25.1579 28.4153 25.1579Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0199 27.0198C27.2776 27.0198 27.4865 26.8109 27.4865 26.5532C27.4865 26.2955 27.2776 26.0865 27.0199 26.0865C26.7621 26.0865 26.5532 26.2955 26.5532 26.5532C26.5532 26.8109 26.7621 27.0198 27.0199 27.0198Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8152 27.0198C30.0729 27.0198 30.2818 26.8109 30.2818 26.5532C30.2818 26.2955 30.0729 26.0865 29.8152 26.0865C29.5574 26.0865 29.3485 26.2955 29.3485 26.5532C29.3485 26.8109 29.5574 27.0198 29.8152 27.0198Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47025 25.1579C9.72797 25.1579 9.9369 24.949 9.9369 24.6913C9.9369 24.4335 9.72797 24.2246 9.47025 24.2246C9.21253 24.2246 9.0036 24.4335 9.0036 24.6913C9.0036 24.949 9.21253 25.1579 9.47025 25.1579Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07486 27.0198C8.33259 27.0198 8.54151 26.8109 8.54151 26.5532C8.54151 26.2955 8.33259 26.0865 8.07486 26.0865C7.81714 26.0865 7.60822 26.2955 7.60822 26.5532C7.60822 26.8109 7.81714 27.0198 8.07486 27.0198Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8702 27.0198C11.1279 27.0198 11.3368 26.8109 11.3368 26.5532C11.3368 26.2955 11.1279 26.0865 10.8702 26.0865C10.6124 26.0865 10.4035 26.2955 10.4035 26.5532C10.4035 26.8109 10.6124 27.0198 10.8702 27.0198Z",
    fill: "#FF8B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_1672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.526,
    height: 42.5474,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.39541b8dd71a6480b02ea345601ae5a7.svg";
export { ForwardRef as ReactComponent };